import React from 'react';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import IconVehicle from '../icons/car_icon.svg'

export default function MobileNavigation({mobileSidebarOpen,setMobileSidebarOpen}){
	const [tabValue, setTabValue] = React.useState(0);
    return (
        <BottomNavigation
			showLabels
			value={tabValue}
			onChange={(event, newValue) => {
					setMobileSidebarOpen(true);

			}}
		>
			<BottomNavigationAction 
				label="Vehicles" 
				icon={
					<img src={IconVehicle} alt="Vehicles" width={"20px"} style={{paddingBottom : "4px"}} />
				} 
				onClick={
					() =>{
						console.log("Open Vehicles Sidebar")
						setMobileSidebarOpen(true)
					}
				}
			/>

      </BottomNavigation>
    )
}